import SurveyResults from './SurveyResultsContainer';

export default SurveyResults;
